import { takeEvery } from 'redux-saga'

import actions from 'actions'
import { eventGroupLoadPage, eventGroupLoadPerformances, eventGroupLoadPastPerformances } from './event-group-sagas'

export function* watchEventGroupLoadPage() {
  yield* takeEvery(actions.EVENT_GROUP_LOAD_PAGE, eventGroupLoadPage)
}

export function* watchEventGroupLoadPerformances() {
  yield* takeEvery(actions.EVENT_GROUP_LOAD_PERFORMANCES, eventGroupLoadPerformances)
}

export function* watchEventGroupLoadPastPerformances() {
  yield* takeEvery(actions.EVENT_GROUP_LOAD_PAST_PERFORMANCES, eventGroupLoadPastPerformances)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/event-group/event-group-watchers.js
 **/